import { Button } from "components/Form/Button";
import { Modal } from "components/Modal";
import { memo } from "react";
import { AppRoutes } from "types";

interface PasswordSetSuccessModalProps {
  show: boolean;
}

export const PasswordSetSuccessModal = memo(function PasswordSetSuccessModal({
  show,
}: PasswordSetSuccessModalProps) {
  return (
    <Modal show={show} onClose={() => {}}>
      <div className="text-center space-y-8 p-8 pb-10">
        {/* Success Icon */}
        <div className="flex justify-center mb-4">
          <div className="w-20 h-20 rounded-full bg-green-500 flex items-center justify-center">
            <svg
              className="w-12 h-12 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={3}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        </div>

        {/* Success Message */}
        <div className="space-y-3">
          <p className="text-24 font-semibold text-gray-900">
            Password Set Successfully! 🎉
          </p>
          <p className="text-858494">
            You can now log in with your new password
          </p>
        </div>

        {/* Go to Login Button */}
        <div className="pt-4">
          <Button to={AppRoutes.login} type="button" className="w-full">
            Go to Login
          </Button>
        </div>
      </div>
    </Modal>
  );
});
